module.exports = __webpack_public_path__ + "static/img/40.b455809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/40.png
// module id = 4tQ6
// module chunks = 0